import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  getTableAcl,
  saveTableAcl,
  deleteTableAcl,
  newAclCreated,
  deletedAcl,
  updateAclBatch,
  newUpdatedAclRecords,
  getErrorMessage,
  updateTableAclRecords,
  saveBatchTableAcl,
  newlyCreatedAclBatch
} from '../actions/tableacl.actions';

@Injectable()
export class TableAclEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);

  getTableAcl$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getTableAcl),
        map((action) => {
          if (!action.apiConstants) {
            return;
          }
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.tableid).subscribe(
            (result: any) => {
              if (result) {
                this.store.dispatch(updateTableAclRecords({ tableAclRecords: result }));
              }
            }
          );
        })
      ),
    { dispatch: false }
  );

  saveTableAcl$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveTableAcl),
        map((action: any) => {
          if (!action.saveapiConstants?.method) {
            return;
          }
          this.baseService[action.saveapiConstants.method](action.saveapiConstants, action.aclData).subscribe(
            (result: any) => {
              // if (action.saveapiConstants.method==='put') {
              //   this.showMessage('success', 'Action updated successfully');
              // }
              // else if (action.saveapiConstants.method==="post") {
              //   this.showMessage('success', 'Action Created Successfully');
              // }
              this.store.dispatch(
                newAclCreated({
                  createdAcl: result
                })
              );
            },
            (err) => {
              console.log('error');
              console.log(err);
              this.store.dispatch(
                getErrorMessage({
                  errorMessage: err
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  deleteTableAcl$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteTableAcl),
        map((action) => {
          if (!action.apiConstants?.method) {
            return;
          }
          this.baseService[action.apiConstants.method](action.apiConstants, action.ids).subscribe(
            (result: any) => {
              this.store.dispatch(
                deletedAcl({
                  deletedSid: action.ids
                })
              );
            },
            (err) => {
              console.log('error');
              console.log(err);
              this.store.dispatch(
                getErrorMessage({
                  errorMessage: err
                })
              );
            }
          );
        })
      ),
    { dispatch: false }
  );

  updateAclBatch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateAclBatch),
        map((action) => {
          if (!action.apiConstants?.method) {
            return;
          }
          this.baseService[action.apiConstants.method](action.apiConstants, action.actionIds).subscribe(
            (result: any) => {
              if (result) {
                this.showMessage('success', 'Permissions copied successfully');
                this.store.dispatch(newUpdatedAclRecords({ updatedRecords: result }));
              }
            },
            (err) => {
              console.log('error');
              console.log(err);
              this.store.dispatch(
                getErrorMessage({
                  errorMessage: err
                })
              );
            }
          );
        })
      ),
    { dispatch: false }
  );

  saveBatchTableAcl$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveBatchTableAcl),
        map((action: any) => {
          if (!action.saveapiConstants?.method) {
            return;
          }
          this.baseService[action.saveapiConstants.method](action.saveapiConstants, action.aclData).subscribe(
            (result: any) => {
              this.store.dispatch(
                newlyCreatedAclBatch({
                  newlyCreatedaclDataBatch: result
                })
              );
            },
            (err) => {
              console.log('error');
              console.log(err);
              this.store.dispatch(
                getErrorMessage({
                  errorMessage: err
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
